export function hasResource(resource, role = "ADMISSION") {
    const stored = sessionStorage.getItem("rolePermissions");
    if (!stored) return false;
  
    let rolePermissions;
    try {
      rolePermissions = JSON.parse(stored);
    } catch {
      return false;
    }
  
    return !!rolePermissions?.[role]?.[resource];
  }